<template>
  <integration-list class="p-5"></integration-list>
</template>

<script>
  import IntegrationList from '@/components/administration/integration/common/IntegrationList'

  export default {
    components: {
      'integration-list': IntegrationList
    }
  }
</script>
